import React from "react";
const ProfileTab = ({ selectTab, setTab }) => {
  const onSetTab = (e) => {
    setTab(e)
  }
  return (
    <div className="tab-profile">
      {/* <div className={`tab ${selectTab === 0 ? 'active' : '' }`} onClick={()=> onSetTab(0) }>ข้อมูลส่วนตัว</div> */}
      {/* <div className={`tab ${selectTab === 1 ? 'active' : '' }`} onClick={()=> onSetTab(1) }>ใบหัก ณ ที่จ่าย</div> */}
    </div>
  );
};
export default ProfileTab;
